// src/pages/DeleteAccountInfo.jsx
import React from "react";

export default function DeleteAccountInfo() {
  return (
    <div style={{ maxWidth: "900px", margin: "0 auto", padding: "24px" }}>
      <h1>Eliminación de cuenta y datos en MyShopCity</h1>
      <p><strong>Última actualización:</strong> 12/11/2025</p>

      <p>
        En <strong>MyShopCity</strong> nos tomamos muy en serio la privacidad y el
        control que cada persona tiene sobre su información. Por esto, dentro de
        la aplicación existe una opción para <strong>eliminar tu cuenta y todos tus datos
        asociados</strong>.
      </p>
      <p>
        A continuación explicamos cómo funciona este proceso y qué información se elimina.
      </p>

      <h2>1. ¿Dónde está la opción para eliminar mi cuenta?</h2>
      <p>
        Dentro de la app móvil, en la sección de <strong>Perfil</strong>, al final de la
        pantalla encontrarás un botón que dice:
      </p>
      <p><em>“Eliminar mi cuenta”</em></p>
      <p>
        Esta opción solo está disponible para el propio usuario desde su sesión, con el
        objetivo de proteger la seguridad de la cuenta.
      </p>

      <h2>2. Confirmación mediante código de seguridad</h2>
      <p>
        Para evitar que alguien elimine su cuenta por error, el proceso incluye un paso
        adicional de seguridad:
      </p>
      <ul>
        <li>
          Al presionar <strong>“Eliminar mi cuenta”</strong>, la app mostrará en pantalla
          un <strong>código de confirmación</strong>.
        </li>
        <li>El usuario debe escribir ese código exactamente en el campo indicado.</li>
        <li>
          Después de introducir el código correcto, se activa el botón
          <strong> “Eliminar cuenta”</strong>.
        </li>
        <li>
          Al confirmar, se inicia el proceso de eliminación de la cuenta y los datos.
        </li>
      </ul>
      <p>Si el código no coincide, <strong>no se elimina ningún dato</strong>.</p>

      <h2>3. ¿Qué datos se eliminan?</h2>
      <p>
        Al completar el proceso, se eliminarán de forma permanente todos los datos
        personales del usuario en MyShopCity, incluyendo:
      </p>
      <ul>
        <li>
          La cuenta de autenticación en <strong>Firebase Authentication</strong>.
        </li>
        <li>
          Todos los datos asociados en <strong>Firestore</strong>, tales como:
          <ul>
            <li>Perfil de usuario (nombre, correo, dirección, teléfono, ciudad, etc.).</li>
            <li>Historial de compras como usuario que compra.</li>
            <li>Favoritos y lista de productos guardados.</li>
            <li>Carrito de compras.</li>
            <li>Chats asociados a su cuenta.</li>
            <li>
              Si es vendedor:
              <ul>
                <li>Datos de su tienda.</li>
                <li>Productos publicados.</li>
                <li>Historial de ventas.</li>
                <li>Historial de compras como vendedor.</li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      <p>
        Una vez completada la eliminación:
      </p>
      <ul>
        <li>El usuario <strong>no podrá volver a acceder</strong> a su antigua cuenta.</li>
        <li>
          <strong>No existe opción de recuperar</strong> la información ni reactivar la
          cuenta eliminada.
        </li>
        <li>
          Si desea usar la plataforma de nuevo, tendrá que crear una
          <strong> nueva cuenta desde cero</strong>.
        </li>
      </ul>

      <h2>4. ¿Qué ocurre con las ventas ya realizadas?</h2>
      <p>
        Para proteger a los compradores y mantener un registro básico de sus pedidos:
      </p>
      <ul>
        <li>
          Las <strong>compras ya realizadas</strong> seguirán apareciendo en el historial
          del usuario que compró.
        </li>
        <li>
          Sin embargo, el perfil del vendedor se mostrará como
          <strong> “Cuenta eliminada”</strong> (o equivalente).
        </li>
        <li>
          No se mostrarán datos de contacto ni información personal del vendedor, y el
          comprador no podrá acceder a su antiguo perfil ni a sus productos.
        </li>
      </ul>

      <h2>5. ¿Cuándo se eliminan los datos?</h2>
      <p>
        La eliminación de la cuenta y de los datos del usuario se ejecuta de forma
        inmediata en la base de datos principal.
      </p>
      <p>
        En caso de existir copias de seguridad o registros técnicos, estos se conservan
        únicamente el tiempo estrictamente necesario por motivos de seguridad, funcionamiento
        interno o cumplimiento legal, y no se utilizan para fines comerciales.
      </p>

      <h2>6. Importante antes de eliminar tu cuenta</h2>
      <p>Antes de borrar tu cuenta, te recomendamos:</p>
      <ul>
        <li>
          Asegurarte de no tener <strong>pedidos pendientes</strong> o reclamaciones abiertas.
        </li>
        <li>
          Guardar cualquier información que desees conservar (por ejemplo, comprobantes o
          detalles de compras).
        </li>
      </ul>
      <p>
        Una vez confirmada la eliminación,{" "}
        <strong>no podremos recuperar tu cuenta ni tus datos.</strong>
      </p>

      <h2>7. Contacto para dudas</h2>
      <p>
        Si tienes preguntas sobre la eliminación de datos o necesitas ayuda con el proceso,
        puedes escribirnos a:
      </p>
      <p>
        📧 <a href="myshopcity@gmail.com">myshopcity@gmail.com</a>
      </p>
    </div>
  );
}
